import React, { memo } from "react";
import useStyles from "./styles";
import InformationItem from "./components/InformationItem";
import ImagesConfig from "components/ImagesConfig";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { isEmpty } from "lodash";

const Information = props => {
	const classes = useStyles();
	const { data, dataInfoLoyalty } = props;
	const {
		owner,
		image,
		crmLevel,
		crmRewardLevel,
		purchaseRate,
		numOfWeekPurchase
	} = data;

	const isLocal = window.location.host === "localhost:3000";
	const isName = data?.isShow?.isName || false; //Tên
	const isLevel = data?.isShow?.isLevel || false; // Hạng
	const isPurchaseRate = data?.isShow?.isPurchaseRate || false; // Tỉ trọng mua hàng
	const isNumOfWeekPurchase = data?.isShow?.isNumOfWeekPurchase || false; // Số tuần mua hàng

	return (
		<Grid classes={{ root: classes.rootInformation }}>
			<Grid classes={{ root: classes.rootBg }}>
				<Grid container alignItems="center">
					{isName && (
						<InformationItem
							icon={
								<Grid classes={{ root: classes.avatar }}>
									<ImagesConfig
										image={image}
										imageDefault={Images.icAvatar}
										width={32}
										height={32}
									/>
								</Grid>
							}
							title={"Xin chào,"}
							value={owner || "_"}
						/>
					)}
					{isLevel && (
						<InformationItem
							icon={
								<ImagesConfig
									image={
										!isEmpty(dataInfoLoyalty)
											? isLocal
												? `https://sb-shop.kido.vn${dataInfoLoyalty[crmLevel]?.logo}`
												: dataInfoLoyalty[crmLevel]
														?.logo
											: Images.icCopperLevel1
									}
									imageDefault={Images.icCopperLevel1}
									width={32}
									height={32}
								/>
							}
							isBorder={isName}
							title={`Hạng:
							${!isEmpty(dataInfoLoyalty) ? dataInfoLoyalty[crmLevel]?.levelName : "_"}`}
							value={`Thưởng ${crmRewardLevel || "_"}%`}
						/>
					)}
				</Grid>
				{(isPurchaseRate || isNumOfWeekPurchase) && (
					<Grid classes={{ root: classes.border }} />
				)}
				<Grid container alignItems="center">
					{isPurchaseRate && (
						<InformationItem
							icon={
								<img
									src={Images.icPurchase}
									alt={"icPurchase"}
								/>
							}
							title={"Tỉ trọng mua hàng"}
							value={purchaseRate || "_"}
						/>
					)}
					{isNumOfWeekPurchase && (
						<InformationItem
							icon={
								<img
									src={Images.icCartWeek}
									alt={"icCartWeek"}
								/>
							}
							title={"Số tuần mua hàng"}
							isBorder={isPurchaseRate}
							value={numOfWeekPurchase || "_"}
						/>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(Information);
